module.exports = "<app-menu [verticalMenu]=\"true\" [customClass]=\"'sidenav-button'\"></app-menu>\n"